export default function flightCapableDeviceFilter(devices) {
	return devices.filter(d => d.state !== 'DECOMMISSIONED' && !d.isHidden && !d.parentDeviceId && d.type !== 'GRS' && d.type !== 'SRS')
}